import { apiClient } from "./client";
import type { BusinessHours, AvailabilityOverride } from "@abejon/shared";

interface HoursResponse {
  hours: BusinessHours[];
}

interface OverridesResponse {
  overrides: AvailabilityOverride[];
}

interface OverrideResponse {
  override: AvailabilityOverride;
}

export async function getBusinessHours(businessId: string) {
  return apiClient<HoursResponse>(`/availability/${businessId}/hours`);
}

export async function updateBusinessHours(
  businessId: string,
  hours: {
    dayOfWeek: number;
    startTime: string;
    endTime: string;
    isOpen: boolean;
  }[]
) {
  return apiClient<HoursResponse>(`/availability/${businessId}/hours`, {
    method: "PUT",
    body: { hours },
  });
}

export async function getOverrides(businessId: string) {
  return apiClient<OverridesResponse>(`/availability/${businessId}/overrides`);
}

export async function createOverride(
  businessId: string,
  data: {
    date: string;
    isBlocked: boolean;
    startTime?: string;
    endTime?: string;
  }
) {
  return apiClient<OverrideResponse>(`/availability/${businessId}/overrides`, {
    method: "POST",
    body: data,
  });
}

export async function deleteOverride(businessId: string, overrideId: string) {
  return apiClient<{ message: string }>(
    `/availability/${businessId}/overrides/${overrideId}`,
    { method: "DELETE" }
  );
}
